import axios from 'axios';

// initial state
const pointsState = {
  rentPlus: [],
};

// getters
const getters = {};

// actions
const actions = {
  GET_USER_RENT_POINTS({ commit, rootState }) {
    axios
      .get(`${rootState.api}/user/rent-plus/tiers`)
      .then((res) => commit('SET_USER_POINTS', res.data.data)).catch((error) => console.log(error));
  },
};

// mutations
const mutations = {
  SET_USER_POINTS(state, res) {
    state.rentPlus = res;
  },
};

export default {
  namespaced: true,
  state: pointsState,
  getters,
  actions,
  mutations,
};
